export default function returnFalse() {
    return false;
}



// WEBPACK FOOTER //
// ./src/widget/ScrollBar/utils/returnFalse.js